"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react');



var _useInbox = require('shared/hooks/inbox/useInbox');
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);











const EMPTY_MAP = {}

 const useArchiveTransaction = ({
  activeFilter,
  onReset,
  showSuccessBar,
  showWarningBar,
  onArchived,
}) => {
  const [archivingBlobjectKeys, setArchivingBlobjectKeys] = _react.useState.call(void 0, EMPTY_MAP)

  const isBlobjectBeingArchived = _react.useCallback.call(void 0, 
    (blobjectKey) => !!archivingBlobjectKeys[blobjectKey],
    [archivingBlobjectKeys],
  )

  // In Archived, `teamKeys` unarchives a chat for those teams (the chat's
  // "Archive for…" command, which the server allows only for your own teams)
  // rather than your own archive.
  const onToggleBlobjectArchived = _react.useCallback.call(void 0, 
    async (blobjectKey, teamKeys) => {
      const shouldArchive = activeFilter === _useInbox.BlobjectFilter.ACTIVE
      const act = async () => {
        if (!shouldArchive && _optionalChain([teamKeys, 'optionalAccess', _ => _.length])) {
          const TeamKeys = Object.fromEntries(teamKeys.map(k => [k, false])) 
          return _actions2.default.setBlobjectCompletedForTeams({ BKey: blobjectKey, TeamKeys })
            .then(() => true).catch(() => false)
        }
        const f = shouldArchive
          ? _actions2.default.completeBlobject
          : _actions2.default.uncompleteBlobject

        return f(blobjectKey).then(() => true).catch(() => false)
      }

      const markBlobject = (b) =>
        setArchivingBlobjectKeys(m => ({ ...m, [blobjectKey]: b }))

      markBlobject(true)
      const hasArchivedSuccessfully = await act()
      if (hasArchivedSuccessfully) {
        // Undo is offered at once, while the list refreshes.
        const offersUndo = shouldArchive && !!onArchived
        if (offersUndo) onArchived(blobjectKey)
        await onReset().catch(() => null)
        if (!offersUndo) showSuccessBar(`Successfully ${shouldArchive ? 'archived' : 'unarchived'} conversation`)
      } else showWarningBar(`Failed to ${shouldArchive ? 'archive' : 'unarchive'} conversation`)

      markBlobject(false)
    },
    [activeFilter, onReset, showSuccessBar, showWarningBar, onArchived],
  )

  // Undo for a chat just archived: unarchive it and refresh the list.
  const onUndoArchive = _react.useCallback.call(void 0, 
    async (blobjectKey) => {
      const hasUnarchived = await _actions2.default.uncompleteBlobject(blobjectKey).then(() => true).catch(() => false)
      if (!hasUnarchived) return showWarningBar('Failed to unarchive conversation')
      await onReset().catch(() => null)
    },
    [onReset, showWarningBar],
  )

  return {
    onToggleBlobjectArchived,
    onUndoArchive,
    isBlobjectBeingArchived,
  }
}; exports.useArchiveTransaction = useArchiveTransaction
